import { Navigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  if (!isLoggedIn) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

export default AuthRoute;
